import { Reveal, Eyebrow } from "@/components/Reveal";
import { ShieldCheck, Handshake, Globe2 } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const ASSURANCES = [
  { icon: Handshake, text: "A confidential working session — not a sales pitch" },
  { icon: ShieldCheck, text: "Senior-led, from first call to close-out" },
  { icon: Globe2, text: "Global delivery across enterprise and mid-market" },
];

export default function FounderCta() {
  return (
    <section className="relative bg-surface/40 py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid items-center gap-16 lg:grid-cols-12">
          <div className="lg:col-span-9">
            <Reveal>
              <Eyebrow>The practice</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <blockquote className="mt-10 font-display text-3xl font-light leading-[1.2] tracking-tight sm:text-4xl lg:text-5xl">
                &ldquo;Trust is the product.
                <br />
                <span className="font-semibold text-accent">Everything else is delivery.&rdquo;</span>
              </blockquote>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-8 max-w-xl text-base leading-relaxed text-slate-400">
                AiCendor is led by an AIGP-certified AI governance professional with deep experience
                across PMO transformation and cybersecurity. The same senior people who scope your
                engagement deliver it — no bait-and-switch, no junior handoffs.
              </p>
            </Reveal>
            <div className="mt-10 space-y-4">
              {ASSURANCES.map(({ icon: Icon, text }, i) => (
                <Reveal key={text} delay={0.25 + i * 0.1}>
                  <div className="flex items-center gap-4 text-sm text-slate-300 sm:text-base">
                    <Icon className="h-4 w-4 shrink-0 text-accent" strokeWidth={1.75} />
                    {text}
                  </div>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.5}>
              <div className="mt-12 flex flex-col items-start gap-4 sm:flex-row sm:items-center">
                <button
                  data-testid="founder-cta-button"
                  onClick={() => scrollToId("book")}
                  className="btn-sweep btn-sweep-light border border-accent bg-accent px-8 py-4 font-mono text-xs font-medium uppercase tracking-[0.22em] text-ink"
                >
                  Book a consultation call
                </button>
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
                  No obligation. Strictly confidential.
                </span>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
